/* Holster Redesign 2026 – cards, quick add, rails, hero, bundle builder, tiers. No deps. */
(function () {
  'use strict';
  var d = document;

  function add(items, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    var done = function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); } };
    var fail = function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } };
    if (window.HolsterCart && typeof window.HolsterCart.addItemsAndRefresh === 'function') {
      return Promise.resolve(window.HolsterCart.addItemsAndRefresh(items, { openDrawer: true })).then(done, function () {
        fail(); location.href = '/cart';
      });
    }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { done(); location.href = '/cart'; }, fail);
  }
  window.HR26 = { add: add };

  // Card: strength pills / select / quick add
  d.addEventListener('click', function (e) {
    var pill = e.target.closest('.hr-pill[data-hr-variant]');
    if (pill) {
      e.preventDefault();
      var card = pill.closest('[data-hr-card]');
      if (!card || pill.disabled) return;
      card.querySelectorAll('.hr-pill').forEach(function (x) { x.classList.toggle('is-active', x === pill); x.setAttribute('aria-checked', x === pill ? 'true' : 'false'); });
      var b = card.querySelector('[data-hr-add]');
      if (b) b.setAttribute('data-hr-add', pill.getAttribute('data-hr-variant'));
      var pr = card.querySelector('[data-hr-price]');
      if (pr && pill.dataset.price) pr.textContent = pill.dataset.price;
      return;
    }
    var swb = e.target.closest('[data-hr-swatch]');
    if (swb) {
      e.preventDefault();
      var sc = swb.closest('[data-hr-card]');
      if (!sc || swb.disabled) return;
      sc.querySelectorAll('[data-hr-swatch]').forEach(function (x) { x.classList.toggle('is-active', x === swb); x.setAttribute('aria-checked', x === swb ? 'true' : 'false'); });
      var sb = sc.querySelector('[data-hr-add]');
      if (sb) sb.setAttribute('data-hr-add', swb.getAttribute('data-hr-swatch'));
      var sp = sc.querySelector('[data-hr-price]');
      if (sp && swb.dataset.price) sp.textContent = swb.dataset.price;
      var sn = sc.querySelector('[data-hr-swname]');
      if (sn) sn.textContent = swb.dataset.name || '';
      var si = sc.querySelector('.hr-card__img');
      if (si && swb.dataset.img) { si.removeAttribute('srcset'); si.src = swb.dataset.img; }
      return;
    }
    var btn = e.target.closest('[data-hr-add]');
    if (btn && btn.tagName === 'BUTTON') {
      e.preventDefault();
      var id = parseInt(btn.getAttribute('data-hr-add'), 10);
      if (id) add([{ id: id, quantity: parseInt(btn.dataset.qty || '1', 10) }], btn);
      return;
    }
    var arrow = e.target.closest('[data-hr-scroll]');
    if (arrow) {
      var track = d.getElementById(arrow.getAttribute('aria-controls'));
      if (track) track.scrollBy({ left: (arrow.dataset.hrScroll === 'prev' ? -1 : 1) * Math.max(240, track.clientWidth * 0.85), behavior: 'smooth' });
      return;
    }
    var tab = e.target.closest('[data-hr-tab]');
    if (tab) {
      var root = tab.closest('[data-hr-tabs]');
      root.querySelectorAll('[data-hr-tab]').forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      root.querySelectorAll('[data-hr-panel]').forEach(function (pnl) { pnl.hidden = pnl.getAttribute('data-hr-panel') !== tab.getAttribute('data-hr-tab'); });
      return;
    }
  });
  d.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-hr-select]');
    if (!sel) return;
    var card = sel.closest('[data-hr-card]');
    var b = card && card.querySelector('[data-hr-add]');
    if (b) b.setAttribute('data-hr-add', sel.value);
    var opt = sel.options[sel.selectedIndex];
    var pr = card && card.querySelector('[data-hr-price]');
    if (pr && opt && opt.dataset.price) pr.textContent = opt.dataset.price;
  });

  // Rails: arrow state
  function railState(track) {
    var wrap = track.closest('[data-hr-rail]');
    if (!wrap) return;
    var max = track.scrollWidth - track.clientWidth - 4;
    var prev = wrap.querySelector('[data-hr-scroll="prev"]');
    var next = wrap.querySelector('[data-hr-scroll="next"]');
    if (prev) prev.disabled = track.scrollLeft <= 4;
    if (next) next.disabled = track.scrollLeft >= max;
  }
  function initRails() {
    d.querySelectorAll('[data-hr-track]').forEach(function (t) {
      if (t.__hr) return; t.__hr = 1;
      railState(t);
      t.addEventListener('scroll', function () { railState(t); }, { passive: true });
    });
  }

  // Hero slider (scroll-snap + dots + autoplay that pauses on interaction)
  function initHero() {
    d.querySelectorAll('[data-hr-hero]').forEach(function (h) {
      if (h.__hr) return; h.__hr = 1;
      var track = h.querySelector('[data-hr-hero-track]');
      var dots = h.querySelectorAll('[data-hr-dot]');
      var slides = track ? track.children : [];
      if (!track || slides.length < 2) return;
      var cur = 0, timer = null, paused = false;
      function go(i) { cur = (i + slides.length) % slides.length; track.scrollTo({ left: slides[cur].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
      function mark() {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        cur = i;
        dots.forEach(function (dt, k) { dt.classList.toggle('is-active', k === i); dt.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
      dots.forEach(function (dt, k) { dt.addEventListener('click', function () { paused = true; go(k); }); });
      ['pointerdown', 'touchstart', 'focusin', 'mouseenter'].forEach(function (ev) { h.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      /* no autoplay: avoids motion/CLS, user swipes or taps dots */
    });
  }

  // LIQ IT bundle builder
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return (fmt || '{{amount_with_comma_separator}} €').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }
  function initBuilder() {
    d.querySelectorAll('[data-hr-builder]').forEach(function (root) {
      if (root.__hr) return; root.__hr = 1;
      var data = JSON.parse(root.querySelector('script[type="application/json"]').textContent || '{}');
      var unit = data.unit || 0;
      var strength = root.querySelector('[data-hr-strength] .is-active');
      var qty = {};
      function curStrength() { var a = root.querySelector('[data-hr-strength] .is-active'); return a ? a.dataset.s : data.defaultStrength; }
      function update() {
        var s = curStrength(), n = 0, items = [];
        root.querySelectorAll('[data-hr-flavor]').forEach(function (f) {
          var vid = (data.map[f.dataset.hrFlavor] || {})[s];
          var q = qty[f.dataset.hrFlavor] || 0;
          f.classList.toggle('is-unavailable', !vid);
          f.querySelectorAll('button').forEach(function (b) { if (b.dataset.op === 'plus') b.disabled = !vid; });
          if (!vid && q) { qty[f.dataset.hrFlavor] = 0; q = 0; }
          f.querySelector('[data-hr-q]').textContent = q;
          f.classList.toggle('is-picked', q > 0);
          if (vid && q) { items.push({ id: vid, quantity: q }); n += q; }
        });
        var pct = n >= 25 ? 15 : (n >= 10 ? 10 : 0);
        var total = unit * n, disc = n * (unit - Math.floor(unit * pct / 100)); /* Shopify: % discount floored per unit (cents) */
        root.querySelector('[data-hr-count]').textContent = n;
        root.querySelector('[data-hr-total]').textContent = money(disc, data.fmt);
        var was = root.querySelector('[data-hr-was]');
        was.textContent = pct ? money(total, data.fmt) : '';
        var msg = root.querySelector('[data-hr-msg]');
        if (document.documentElement.lang === 'en') { msg.textContent = n === 0 ? 'Select flavors – From 10 bottles: 10 % discount · From 25 bottles: 15 % discount' : (n < 10 ? (10 - n) + (10 - n === 1 ? ' more bottle' : ' more bottles') + ' to −10 %' : (n < 25 ? '−10 % active · ' + (25 - n) + (25 - n === 1 ? ' more bottle' : ' more bottles') + ' to −15 %' : '15 % discount applied')); } else
        msg.textContent = n === 0 ? 'Sorten auswählen – Ab 10 Flaschen: 10 % Rabatt · Ab 25 Flaschen: 15 % Rabatt' : (n < 10 ? 'Noch ' + (10 - n) + (10 - n === 1 ? ' Flasche' : ' Flaschen') + ' bis −10 %' : (n < 25 ? '−10 % aktiv · noch ' + (25 - n) + (25 - n === 1 ? ' Flasche' : ' Flaschen') + ' bis −15 %' : '15 % Rabatt berücksichtigt'));
        root.querySelectorAll('[data-hr-step]').forEach(function (st) { st.classList.toggle('is-on', n >= parseInt(st.dataset.hrStep, 10)); });
        var btn = root.querySelector('[data-hr-builder-add]');
        btn.disabled = n === 0;
        btn.__items = items;
      }
      root.addEventListener('click', function (e) {
        var sb = e.target.closest('[data-hr-strength] button');
        if (sb) { root.querySelectorAll('[data-hr-strength] button').forEach(function (b) { b.classList.toggle('is-active', b === sb); b.setAttribute('aria-pressed', b === sb ? 'true' : 'false'); }); update(); return; }
        var ob = e.target.closest('[data-hr-flavor] button[data-op]');
        if (ob) { var k = ob.closest('[data-hr-flavor]').dataset.hrFlavor; qty[k] = Math.max(0, Math.min(50, (qty[k] || 0) + (ob.dataset.op === 'plus' ? 1 : -1))); update(); return; }
        var ab = e.target.closest('[data-hr-builder-add]');
        if (ab && ab.__items && ab.__items.length) add(ab.__items, ab);
      });
      update();
    });
  }

  function init() { initRails(); initHero(); initBuilder(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', init);
  // facets / infinite scroll re-render
  var moT = 0;
  new MutationObserver(function () { if (moT) return; moT = requestAnimationFrame(function () { moT = 0; initRails(); }); }).observe(d.body || d.documentElement, { childList: true, subtree: true });
})();
